module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/en_1-938c2471a3bb94ad2c51d57a14b2907e.jpg";